import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/productions')({
  component: () => (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <Outlet />
    </div>
  ),
});
